export default "__VITE_ASSET__jRPhtbRb__"